import * as React from 'react';

export default function TerminalAvatar({ className = '' }) {
  return (
    <div className={`${className} h-full w-full flex items-center justify-center`}>
      <div className="w-full max-w-[36rem] border-4 border-black bg-slate-900 shadow-nero">
        <div className="h-8 md:h-9 flex items-center px-3 md:px-4 bg-slate-950 border-b-4 border-black">
          <div className="flex items-center gap-2">
            <span className="block h-3.5 w-3.5 md:h-4 md:w-4 rounded-full border-2 border-black bg-rose-600" aria-hidden="true" />
            <span className="block h-3.5 w-3.5 md:h-4 md:w-4 rounded-full border-2 border-black bg-yellow-300" aria-hidden="true" />
            <span className="block h-3.5 w-3.5 md:h-4 md:w-4 rounded-full border-2 border-black bg-lime-400" aria-hidden="true" />
          </div>
        </div>

        <div className="bg-slate-950 px-4 pt-3 pb-0 md:px-6 md:pt-4 md:pb-0">
          <p className="font-mono text-lime-400 text-sm md:text-base leading-tight">
            $ whoami<span className="animate-blink">_</span>
          </p>

          <div className="mt-3 h-[14rem] md:h-[18rem] flex items-start justify-center overflow-hidden">
            <img
              src="/image.png"
              alt="Jasen avatar"
              className="h-[22rem] md:h-[28rem] w-auto max-w-none object-contain origin-top scale-110 select-none"
              loading="lazy"
              decoding="async"
              draggable="false"
            />
          </div>
        </div>
      </div>
    </div>
  );
}